import {POST} from "@/services/gateway";

const listJobsOverview = (filter) => {
  return POST('job/overview', filter)
}

export {
  listJobsOverview
}
